import { render, staticRenderFns } from "./TradeHistory.vue?vue&type=template&id=45ba932e&scoped=true&"
import script from "./TradeHistory.vue?vue&type=script&lang=js&"
export * from "./TradeHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ba932e",
  null
  
)

export default component.exports